import React from 'react';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import BaseForm from '../../../../../components/form/BaseForm';
import Input from '../../../../../components/input/Input/Input';
import Select from '../../../../../components/input/Select/Select';
import SearchBox from '../../../../../components/outline/SearchBox';
import { RECOMMEND_PRODUCT_TYPE_SELECT_LIST } from '../../../../../constants/service/app/recommendProductConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  RECOMMEND_PRODUCT_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_PRODUCT_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/recommend/product/models';
import './RecommendProductListSearchBox.scss';

const RecommendReviewListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { recommendProductType, adminName, memo, createDate } = searchData;

  return (
    <SearchBox
      className="recommend-product-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: RECOMMEND_PRODUCT_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
          isInit: true,
        });
        setData({
          path: [],
          value: RECOMMEND_PRODUCT_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*추천 상품 타입*/}
      <BaseForm
        label="추천 타입"
        content={
          <Select
            list={RECOMMEND_PRODUCT_TYPE_SELECT_LIST}
            onChange={(value) =>
              setData({
                path: ['recommendProductType'],
                value,
              })
            }
            defaultValue={recommendProductType}
            value={recommendProductType}
            isTable={false}
          />
        }
      />

      {/*추천인 검색*/}
      <BaseForm
        label="추천인"
        content={
          <Input
            value={adminName}
            onChange={(value) =>
              setData({
                path: ['adminName'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*메모 검색*/}
      <BaseForm
        label="메모"
        content={
          <Input
            value={memo}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*추천 상품 생성일*/}
      <BaseForm
        label="추천 상품 생성일"
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['createDate'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default RecommendReviewListSearchBox;
